import { Grid, Button, TextField } from "@mui/material";
import {useTranslation} from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {Stack} from "@mui/material";
import { ApiContext } from "../../../App";

const FacilityForm = ({ facility}) => {
    const { t } = useTranslation();
    const [facilityTariffs, setFacilityTariffs] = useState([])
    const [errorMessages, setErrorMessages] = useState({});
    
    const [facilityData, setFacilityData] = useState({
        name: "",
        lat: "",
        lon: "",
        electricity_real_time_tariff: "",
        gas_real_time_tariff: ""
    });

    const {facilityApi, tariffApi} = useContext(ApiContext)

    useEffect(() => {
        tariffApi.list(
            facility,
            data => {
                setFacilityTariffs(data)
            },
            () => {
                alert(t("Couldn't connect to server."));  
            }
        )
    }, [facility])

    useEffect(() => {
        facilityApi.retrieve(
            facility,
            data => {
                setFacilityData({
                    name: data.name,
                    lat: data.lat,
                    lon: data.lon,
                    electricity_real_time_tariff: data.electricity_real_time_tariff,
                    gas_real_time_tariff: data.gas_real_time_tariff
                });
            },
            () => {
                alert(t("Couldn't connect to server."));
            }
        )
    },[facility])

    const electricityTariffChangeHandler = (event) => {
        setFacilityData({...facilityData, electricity_real_time_tariff: event.target.value})
    }

    const gasTariffChangeHandler = (event) => {
        setFacilityData({...facilityData, gas_real_time_tariff: event.target.value})
    }

    const submitHandler = (event) => {
        event.preventDefault()
        setErrorMessages({});
        
        const augmentedFacilityData = {
            ...facilityData,
            electricity_real_time_tariff: facilityData.electricity_real_time_tariff === 'Null' ? null : facilityData.electricity_real_time_tariff,
            gas_real_time_tariff: facilityData.gas_real_time_tariff === "Null" ? null : facilityData.gas_real_time_tariff
        }
        const errors = {}
        if (!event.target.name.value) {
            errors['name'] = "Name must have a value"
        }
        if (!event.target.lat.value) {
            errors['lat'] = "Latitude must have a value"
        }
        if (!event.target.lon.value) {
            errors['lon'] = "Longitude must have a value"
        }

        setErrorMessages(errors)

        if(Object.keys(errors).length === 0) {
            facilityApi.updatePartial(facility, augmentedFacilityData, () => {
                alert(t("Updated correctly."))
            }, () => {
                alert(t('Unable to update facility'))
            })
        }
        
    }

    return ( 
            <form onSubmit={submitHandler}>
                <Grid container sx={{ justifyContent: 'space-between', flexDirection: {sm: 'column', md: 'row'}}} gap={5}>
                    <TextField
                        display='inline'
                        label={t("Name")}
                        variant="standard"
                        id={"name"}
                        type="string"
                        value={ facilityData.name ? facilityData.name : "" }
                        onChange={(event) => setFacilityData({...facilityData, name: event.target.value})}
                        sx={{width:'175px'}}
                        error={errorMessages.hasOwnProperty("name")}
                        helperText={errorMessages["name"]? errorMessages["name"]: ""}
                    />
                    <TextField
                        label={t("Latitude")}
                        variant="standard"
                        id={"lat"}
                        type="number"
                        value={ facilityData.lat ? facilityData.lat : "" }
                        onChange={(event) => setFacilityData({...facilityData, lat: event.target.value})}
                        sx={{width:'175px'}}
                        error={errorMessages.hasOwnProperty("lat")}
                        helperText={errorMessages["lat"]? errorMessages["lat"]: ""}
                    />
                    <TextField
                        label={t("Longitude")}
                        variant="standard"
                        id={"lon"}
                        type="number"
                        value={ facilityData.lon ? facilityData.lon : "" }
                        onChange={(event) => setFacilityData({...facilityData, lon: event.target.value})}
                        sx={{width:'175px'}}
                        error={errorMessages.hasOwnProperty("lon")}
                        helperText={errorMessages["lon"]? errorMessages["lon"]: ""}
                    />
                    <Stack direction="column">
                        <label style={{fontSize: '0.75em', color:'grey'}}>{t("Real time electricity tariff")}</label>
                        <select
                            value={facilityData.electricity_real_time_tariff == null ? 'Null' : facilityData.electricity_real_time_tariff}
                            onChange={electricityTariffChangeHandler}
                            style={{width:'175px', maxWidth:'175px', height:'30px', border: 'none', borderBottom: "1px solid grey", fontSize:'16px', textAlign:'left'}}
                        >
                        {
                                facilityTariffs.map((tariff, index) => (
                                    <option value={tariff.url} key={index} >{tariff.name}</option>
                                ))
                        }
                        <option value="Null">Null</option>
                        </select>
                    </Stack>
                    <Stack direction="column">
                        <label style={{fontSize: '0.75em', color:'grey'}}>{t("Real time gas tariff")}</label>
                        <select
                            value={facilityData.gas_real_time_tariff == null ? 'Null' : facilityData.gas_real_time_tariff}
                            onChange={gasTariffChangeHandler}
                            style={{width:'175px', maxWidth:'175px', height:'30px', border: 'none', borderBottom: "1px solid grey", fontSize:'16px', textAlign:'left'}}
                        >
                        {
                                facilityTariffs.map((tariff, index) => (
                                    <option value={tariff.url} key={index} >{tariff.name}</option>
                                ))
                        }
                        <option value="Null">Null</option>
                        </select>
                    </Stack>
                    <Button variant='contained' type='submit' style={{ backgroundColor: '#1976d2' , width: '64px', color: '#fff', borderRadius: '4px'}}>Update</Button>
                </Grid>
        </form>
     );
}
 
export default FacilityForm;